import { UID } from 'types/types';
import { createAction } from 'typesafe-actions';
import {
  AsesState,
  ListData,
  ListFilter,
  ListFilterOptions,
  ListItem,
} from './types';

export const doAsesListLoad = createAction('@doAsesListLoad')<
  {
    type?: 'filter' | 'pullToRefresh';
    useBlockingLoader: boolean;
  } & (
    | {
        append?: never;
        useDraftFilter?: never;
      }
    | {
        append: true;
        useDraftFilter?: false;
      }
    | {
        append?: false;
        useDraftFilter: boolean;
      }
  )
>();

export const doAsesListFilterOpenModal = createAction(
  '@doAsesListFilterOpenModal',
)<{
  setDraft: boolean;
}>();

export const doAsesListFilterLoad = createAction('@doAsesListFilterLoad')<{
  setDraft: boolean;
  // If null, get from current list filter
  organisationIds: string[] | null;
}>();

export const doAsesListFilterOpenOrganisationSelect = createAction(
  '@doAsesListFilterOpenOrganisationSelect',
)<{ getDraft: boolean; openFilterAfterSelect: boolean }>();
export const doAsesListClearOrganisations = createAction(
  '@doAsesListClearOrganisations',
)();

export const doneAsesListFilterLoad = createAction('@doneAsesListFilterLoad')();
export const failAsesListFilterLoad = createAction('@failAsesListFilterLoad')<{
  error: Error;
}>();

export const doAsesListSetLoadStatus = createAction('@doAsesListSetLoadStatus')<
  AsesState['listLoadStatus']
>();

export const doAsesListSetFilterOptions = createAction(
  '@doAsesListSetFilterOptions',
)<ListFilterOptions>();

export const doAsesListSetFilterOptionsDraft = createAction(
  '@doAsesListSetFilterOptionsDraft',
)<ListFilterOptions>();

export const doAsesListSetFilter = createAction('@doAsesListSetFilter')<{
  data: Partial<ListFilter>;
  append: boolean;
  loadList:
    | false
    | {
        useBlockingLoader: boolean;
      };
}>();

export const doAsesListSetFilterDraft = createAction(
  '@doAsesListSetFilterDraft',
)<{
  data: Partial<ListFilter>;
  append: boolean;
}>();

export const doAsesListSetData = createAction('@doAsesListSetData')<ListData>();

export const doAsesListSet = createAction('@doAsesListSet')<{
  list: Record<string, ListItem>;
  page: number;
  totalCount?: number;
  append: boolean;
}>();

export const doAsesListSetItem = createAction('@doAsesListSetItem')<{
  id: string;
  item: ListItem | null;
}>();

export const doAsesAssessmentLoad = createAction('@doAsesAssessmentLoad')<{
  id: UID;
}>();
